import React, {Component} from 'react';

import './Spinner.css';

class Spinner extends Component {
	render() {
		return (
			<div className="Spinner">
				<div className="Spinner-1" />
				<div className="Spinner-2" />
				<div className="Spinner-3" />
			</div>
		);
	}
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/widgets/Spinner.js